import { put, call, takeLatest } from 'redux-saga/effects';
import AdminAPI from '../admin/AdminAPI';
import { saveDemoAnimalSuccess, saveDemoAnimalFail } from './actions';
import { parseApiError } from '../util/api';
import { showNotification } from '../notifications/actions';
import { DEMO_SAVE } from './constants';

function *add (action) {
  try {
    const { data } = yield call(AdminAPI.addCow, action.animal);
    yield put(saveDemoAnimalSuccess(data.animal));
  } catch (error) {
    let msg = parseApiError(error);
    if (error.response && error.response.data) {
      msg = error.response.data;
    }
    yield put(saveDemoAnimalFail(msg, action.animal));
    const name = action.animal ? action.animal.name || '' : '';
    yield put(showNotification(
      `Failed to add animal ${name}`, msg, 'error', 10
    ));
  }
}

function *demoSagas () {
  yield takeLatest(DEMO_SAVE, add);
}

export default demoSagas;
